import {type ConstructorOf} from '@colonist/types'

export namespace ObjectUtils {

    // http://adripofjavascript.com/blog/drips/object-equality-in-javascript.html
    export function isObjectEqual<T>(a: T, b: T): boolean {
        const aProps = Object.getOwnPropertyNames(a)
        const bProps = Object.getOwnPropertyNames(b)

        if(aProps.length != bProps.length) {
            return false
        }

        for(const propName of aProps) {
            if(a[propName] !== b[propName]) return false
        }

        return true
    }

    export function arrayToObjectWithIndexesAsKeys<T>(array: T[]): {[key: string]: T} {
        const object: {[key: string]: T} = {}
        for(let i = 0; i < array.length; i++) {
            object[i] = array[i]
        }

        return object
    }

    export function removeAllPropertiesEqualTo(object: any, value: unknown): void {
        for(const key in object) {
            if(object[key] === value) {
                delete object[key]
            }
        }
    }

    export function isNestedObjectEmpty(obj: Record<string, any>): boolean {
        for(const key in obj) {
            const property = obj[key]

            if(Array.isArray(property)) return false

            const isPropertyObject = typeof property === 'object' && property !== null
            if(!isPropertyObject) return false
            if(!isNestedObjectEmpty(property)) return false
        }

        return true
    }
}

export function objectAsType<T>(object: any, type: ConstructorOf<T>): T {
    if(object instanceof type) {
        return object as T
    }

    throw new Error(`Object is not a ${type.name}`)
}
